import { fork } from 'redux-saga/effects';
import watchTripPositions from './positions/sagas';

export default function* watchDomains() {
  yield fork(watchTripPositions);
}
